import React, { useState } from 'react';
import { useHotkeys } from '@mantine/hooks';
import { MantineColorScheme, MantineProvider, MantineThemeOverride } from '@mantine/core';
import { ModalsProvider } from '@mantine/modals';
import { QueryClient, QueryClientProvider } from 'react-query';
import { CookiesProvider } from 'react-cookie';
import { Notifications } from '@mantine/notifications';
import { LanguageProvider } from './localization';
import 'dayjs/locale/vi';
import { Auth0Provider } from '@auth0/auth0-react';
import { navigate } from 'gatsby';

const onRedirectCallback = (appState: any) => {
    // Use Gatsby's navigate method to replace the url
    navigate(appState?.returnTo || '/');
};

interface ProvidersProps {
    children: React.ReactNode;
    theme: MantineThemeOverride;
    location: any;
}

export function Providers({ children, theme, location }: ProvidersProps) {
    const [colorScheme, setColorScheme] = useState<MantineColorScheme>('dark');
    const toggleColorScheme = (value?: MantineColorScheme) =>
        setColorScheme(value || (colorScheme === 'dark' ? 'light' : 'dark'));

    useHotkeys([['mod+J', () => toggleColorScheme()]]);

    const queryClient = new QueryClient();

    return (<CookiesProvider defaultSetOptions={{ path: '/' }}>
        <MantineProvider theme={theme} forceColorScheme='light' withCssVariables>
            <ModalsProvider>
                <QueryClientProvider client={queryClient}>
                    <LanguageProvider>
                        <Notifications position='bottom-center' />
                        <Auth0Provider
                            domain={process.env.AUTH0_DOMAIN as string}
                            clientId={process.env.AUTH0_CLIENTID as string}
                            onRedirectCallback={onRedirectCallback}
                            authorizationParams={{
                                redirect_uri: process.env.AUTH0_CALLBACK,
                                audience: process.env.GATSBY_API_URL,
                            }}
                        >
                            <>{children}</>
                        </Auth0Provider>
                    </LanguageProvider>
                </QueryClientProvider>
            </ModalsProvider>
        </MantineProvider>
    </CookiesProvider>
    );
}